'use client'

import { Center, Stack, StackSeparator, Text } from '@chakra-ui/react'
import DetailButton from '@/_components/DetailButton'
import { IRedux } from '@/_store/types'
import PointAction from '../PageList/PointAction'
import { useTranslations } from 'next-intl'
import { useSelector } from 'react-redux'
import { Link, useRouter } from '@/i18n/navigation'
import Language from '../Language'
import { getPage } from '@/_utils/PagesList'
import DebitCardIcon from '@/_assets/icon-components/DebitCard'
import { useState } from 'react'
import Auth from '@/_components/Auth'
import { DeliveryAndPaymentIcon, DocumentIcon, InfoIcon } from '@/_assets/icon-components'
import { ShoppingCartIcon } from 'lucide-react'

export default function PageList() {
  const settings = useSelector((state: IRedux) => state.settings)
  const { user } = useSelector((state: IRedux) => state.auth)
  const [isAuthDialog, setIsAuthDialog] = useState(false)
  const [protectedRoute, setProtectedRoute] = useState('')

  const t = useTranslations()
  const router = useRouter()

  return (
    <Stack
      gap={0}
      mt={6}
      minH={'78vh'}
      pb={'80px'}
      roundedTopRight={24}
      roundedTopLeft={24}
      display={'flex'}
      justifyContent={'space-between'}
      bg={'background.card'}
    >
      <Stack
        gap={0}
        separator={<StackSeparator borderColor={'background'} />}
        flexGrow={1}
      >
        {user?.id && (
          <>
            <Link href={'/orders'}>
              <DetailButton
                label={t('my_orders')}
                leftIcon={<ShoppingCartIcon color='#ED3237' />}
              />
            </Link>
            {/* <Link href={'/my-cards'}>
              <DetailButton
                label={t('my_cards')}
                leftIcon={<DebitCardIcon color='#ED3237' />}
              />
            </Link> */}
          </>
        )}
        {settings?.data?.data?.pages?.map((item) => {
          const page = getPage(item.value)

          if (page.protected && !user) {
            return (
              <DetailButton
                key={item.value}
                onClick={() => {
                  setIsAuthDialog(true)
                  setProtectedRoute(page.route)
                }}
                label={t(page.title)}
                leftIcon={page?.icon}
              />
            )
          }
          return (
            <Link href={page.route} key={item?.value}>
              <DetailButton
                label={page?.type === 'dynamic' ? item?.label : t(page.title)}
                leftIcon={page?.icon}
              />
            </Link>
          )
        })}
        <Link href={'/delivery-terms'}>
          <DetailButton
            label={t('delivery_and_payment_terms')}
            leftIcon={<DeliveryAndPaymentIcon color='#ED3237' />}
          />
        </Link>
        <Link href={'/visiting-rules'}>
          <DetailButton
            label={t('visiting_rules')}
            leftIcon={<InfoIcon color='#ED3237' />}
          />
        </Link>
        <Link href={'/public-offer'}>
          <DetailButton
            label={t('public_offer')}
            leftIcon={<InfoIcon color='#ED3237' />}
          />
        </Link>
        <Link href={'/loyaltyoffer'}>
          <DetailButton
            label={t('loyalty_offer')}
            leftIcon={<InfoIcon color='#ED3237' />}
          />
        </Link>
        <Link href={'/llc'}>
          <DetailButton
            label={t('llc')}
            leftIcon={<InfoIcon color='#ED3237' />}
          />
        </Link>
        <Link href={'/certificate'}>
          <DetailButton
            label={t('certificate')}
            leftIcon={<InfoIcon color='#ED3237' />}
          />
        </Link>
        <Link href={'/return-and-refund-policy'}>
          <DetailButton
            label={t('return_and_refund_policy')}
            leftIcon={<InfoIcon color='#ED3237' />}
          />
        </Link>

        <PointAction />
        <Language />
        <div></div>
      </Stack>
      <Auth
        open={isAuthDialog}
        onClose={() => setIsAuthDialog(false)}
        onLastConfirm={() => router.push(protectedRoute)}
      />

      <Center py={4} fontSize={'sm'} color={'text'} gap={1}>
        <Text>Powered by</Text>
        <Link
          style={{ fontWeight: 700 }}
          href={'https://delever.uz/'}
          target='_blank'
        >
          Delever
        </Link>
      </Center>
    </Stack>
  )
}
